// Import uniwersalnego wrappera fetchującego (GET/POST/DELETE itd.)
import { fetchWrapper } from "@/helpers/fetch-wrapper";

// Klasa obsługująca operacje na kontaktach (np. email, telefon)
class ContactsListService {

  /**
   * Dodaje nowy kontakt do systemu.
   * @param {string} contact - Adres e-mail lub numer telefonu.
   * @param {number} typeOfContact - Typ kontaktu (np. 0 = email, 1 = telefon).
   * @param {string} description - Opis kontaktu.
   * @returns odpowiedź z API lub rzuca błąd, jeśli brakuje pól.
   */
  async postNewContact(contact, typeOfContact, description, contactGroupIds = []) {
    // Walidacja – wszystkie pola wymagane
    if (!contact || typeOfContact === undefined || !description) {
      throw new Error('Contact, typeOfContact, and description are required.');
    }

    // Jeśli typ kontaktu jest przekazany jako string, konwertuj na liczbę
    if (typeof(typeOfContact) == 'string') {
      typeOfContact = Number(typeOfContact);
    }

    // Wysłanie POST na endpoint /wanted-contacts
    const response = await fetchWrapper.post(
      process.env.VUE_APP_API_URL + '/wanted-contacts',
      {
        contact: contact,
        typeOfContact: typeOfContact,
        description: description,
        contactGroupIds: Array.isArray(contactGroupIds) ? contactGroupIds : [],
      }
    );
    return response;
  }

  /**
   * Dodaje istniejącego użytkownika systemu jako kontakt. Wartość kontaktu (e-mail/telefon)
   * wylicza serwer z danych konta na podstawie wybranego typu; kontakt zostaje automatycznie
   * powiązany z userem, dzięki czemu user zyskuje widoczność grup ORAZ powiadomienia.
   *
   * @param {number} userId - ID użytkownika systemu.
   * @param {number} typeOfContact - Typ kontaktu (0 = e-mail, 1 = SMS, 2 = MMS).
   * @param {string} description - Opis kontaktu.
   */
  async postNewContactForUser(userId, typeOfContact, description = '', contactGroupIds = []) {
    if (userId === undefined || userId === null || typeOfContact === undefined) {
      throw new Error('userId and typeOfContact are required.');
    }

    return fetchWrapper.post(
      process.env.VUE_APP_API_URL + '/wanted-contacts',
      {
        userId: Number(userId),
        typeOfContact: Number(typeOfContact),
        description: description ?? '',
        contactGroupIds: Array.isArray(contactGroupIds) ? contactGroupIds : [],
      }
    );
  }

  /**
   * Pobiera wszystkie kontakty (domyślnie 10 na stronę, sortowanie malejąco)
   */
  async getAll() {
    try {
      // Parametry zapytania GET (paginacja)
      const params = new URLSearchParams({
        orderDirection: 'desc', // sortowanie malejąco
        page: 1,
        limit: 10
      });

      // Pobranie kontaktów
      const response = await fetchWrapper.get(
        `${process.env.VUE_APP_API_URL}/wanted-contacts?${params.toString()}`
      );

      return response;
    } catch (error) {
      console.error('Error fetching contacts:', error);
    }
  }

  /**
   * Usuwa kontakt po ID.
   * @param {number} id - ID kontaktu do usunięcia.
   */
  async delete(id) {
    try {
      const response = await fetchWrapper.delete(
        `${process.env.VUE_APP_API_URL}/wanted-contacts/${id}`
      );
      return response;
    } catch (error) {
      console.error('Error deleting contact:', error);
    }
  }
}

// Eksport pojedynczej instancji serwisu
export default new ContactsListService();
